// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\SelectCoordinations\AddCoordinationCardsRequest.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { AddCoordinationCardRequest as _AddCoordinationCardRequest, AddCoordinationCardRequestData as _AddCoordinationCardRequestData, AddCoordinationCardRequestOptions as _AddCoordinationCardRequestOptions } from 'data/models/AddCoordinationCardsRequest';

// AddCoordinationCardsRequestData is the class that AddCoordinationCardsRequest serializes to/from
export interface AddCoordinationCardsRequestData {
	
    RequestedCards : _AddCoordinationCardRequestData[] | null;
	
}

// AddCoordinationCardsRequestOptions is the class which may be passed to the AddCoordinationCardsRequest constructor to define optional initial data values
export interface AddCoordinationCardsRequestOptions {
	
    RequestedCards? : _AddCoordinationCardRequestOptions[] | null;
	
}

export class AddCoordinationCardsRequest {
	
    public RequestedCards : SDataArray<_AddCoordinationCardRequest>;
	

    constructor();
    constructor(data : AddCoordinationCardsRequestOptions);
    constructor(data: AddCoordinationCardsRequestOptions | null = null) {
	    
        this.RequestedCards = SArray<_AddCoordinationCardRequest>([]);
	    
    }

    static key(obj : AddCoordinationCardsRequest) {
        return ;
    }
    
    static dataKey(obj : AddCoordinationCardsRequestOptions) {
        return ;
    }

    static update(obj : AddCoordinationCardsRequest, data : AddCoordinationCardsRequestOptions) {
        S.freeze(() => {
	        
	        
        });
    }
}

// AddCoordinationCardRequestData is the class that AddCoordinationCardRequest serializes to/from
export interface AddCoordinationCardRequestData {
	
    CoordinationId : number;
    ProviderId : number;
    ScheduleDateId : number;
	
}

// AddCoordinationCardRequestOptions is the class which may be passed to the AddCoordinationCardRequest constructor to define optional initial data values
export interface AddCoordinationCardRequestOptions {
	
    CoordinationId? : number;
    ProviderId? : number;
    ScheduleDateId? : number;
	
}

export class AddCoordinationCardRequest {
	
    public CoordinationId : DataSignal<number>;
    public ProviderId : DataSignal<number>;
    public ScheduleDateId : DataSignal<number>;
	

    constructor();
    constructor(data : AddCoordinationCardRequestOptions);
    constructor(data: AddCoordinationCardRequestOptions | null = null) {
	    
        this.CoordinationId = jsonableObservable(S.value<number>(data && data.CoordinationId !== undefined ? data.CoordinationId : 0));
        this.ProviderId = jsonableObservable(S.value<number>(data && data.ProviderId !== undefined ? data.ProviderId : 0));
        this.ScheduleDateId = jsonableObservable(S.value<number>(data && data.ScheduleDateId !== undefined ? data.ScheduleDateId : 0));
	    
    }

    static key(obj : AddCoordinationCardRequest) {
        return ;
    }
    
    static dataKey(obj : AddCoordinationCardRequestOptions) {
        return ;
    }

    static update(obj : AddCoordinationCardRequest, data : AddCoordinationCardRequestOptions) {
        S.freeze(() => {
	        
            if (data.CoordinationId !== undefined) obj.CoordinationId(data.CoordinationId);
            if (data.ProviderId !== undefined) obj.ProviderId(data.ProviderId);
            if (data.ScheduleDateId !== undefined) obj.ScheduleDateId(data.ScheduleDateId);
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/AddCoordinationCardsRequest.ts